/* תרבות בגד — theme interactions */
(function () {
  "use strict";

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const money = (cents) =>
    "₪" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    const els = document.querySelectorAll("[data-reveal], [data-reveal-word]");
    if (!("IntersectionObserver" in window) || reduceMotion) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const delay = parseFloat(e.target.dataset.delay || "0");
            setTimeout(() => e.target.classList.add("is-visible"), delay * 1000);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "-60px" }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ---------- Split words for reveal ---------- */
  function initWordReveal() {
    document.querySelectorAll("[data-reveal-word]").forEach((el) => {
      const text = el.textContent.trim();
      el.innerHTML = "";
      text.split(" ").forEach((word, i, arr) => {
        const outer = document.createElement("span");
        const inner = document.createElement("span");
        inner.textContent = word + (i < arr.length - 1 ? "\u00A0" : "");
        inner.style.transitionDelay = i * 0.06 + "s";
        outer.appendChild(inner);
        el.appendChild(outer);
      });
    });
  }

  /* ---------- Marquee (duplicate content) ---------- */
  function initMarquee() {
    document.querySelectorAll(".marquee-track").forEach((track) => {
      if (track.dataset.cloned) return;
      track.dataset.cloned = "1";
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    const header = document.querySelector(".site-header");
    if (!header) return;
    const forceSolid = header.dataset.forceSolid === "true";
    const onScroll = () => {
      if (forceSolid || window.scrollY > 40) header.classList.add("solid");
      else header.classList.remove("solid");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const menu = document.getElementById("mobile-menu");
    const openBtn = document.getElementById("menu-open");
    const closeBtn = document.getElementById("menu-close");
    if (!menu) return;
    openBtn && openBtn.addEventListener("click", () => menu.classList.add("open"));
    closeBtn && closeBtn.addEventListener("click", () => menu.classList.remove("open"));
    menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => menu.classList.remove("open")));
  }

  /* ---------- Hero parallax ---------- */
  function initHeroParallax() {
    if (reduceMotion) return;
    const media = document.querySelector(".hero-media");
    const content = document.querySelector(".hero-content");
    if (!media) return;
    let ticking = false;
    const update = () => {
      const y = window.scrollY;
      const vh = window.innerHeight;
      const p = Math.min(y / vh, 1);
      media.style.transform = `translateY(${p * 20}%) scale(${1 + p * 0.15})`;
      if (content) {
        content.style.transform = `translateY(${p * 60}%)`;
        content.style.opacity = String(1 - Math.min(p / 0.6, 1));
      }
      ticking = false;
    };
    window.addEventListener("scroll", () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ---------- Horizontal lookbook scroll ---------- */
  function initHorizontalLookbook() {
    if (reduceMotion) return;
    const section = document.querySelector(".lookbook-h");
    if (!section) return;
    const track = section.querySelector(".lookbook-track");
    const update = () => {
      const rect = section.getBoundingClientRect();
      const total = section.offsetHeight - window.innerHeight;
      const progress = Math.min(Math.max(-rect.top / total, 0), 1);
      const distance = track.scrollWidth - window.innerWidth + 80;
      track.style.transform = `translateX(${-progress * distance}px)`;
    };
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Custom cursor ---------- */
  function initCursor() {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    document.body.classList.add("has-cursor");
    const dot = document.createElement("div");
    dot.className = "cursor-dot";
    const ring = document.createElement("div");
    ring.className = "cursor-ring";
    document.body.appendChild(dot);
    document.body.appendChild(ring);
    const pos = { x: innerWidth / 2, y: innerHeight / 2 };
    const r = { x: pos.x, y: pos.y };
    document.addEventListener("mousemove", (e) => {
      pos.x = e.clientX; pos.y = e.clientY;
      dot.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      const interactive = e.target.closest("a, button, [data-cursor]");
      ring.classList.toggle("active", !!interactive);
    });
    (function loop() {
      r.x += (pos.x - r.x) * 0.15;
      r.y += (pos.y - r.y) * 0.15;
      ring.style.transform = `translate3d(${r.x}px, ${r.y}px, 0)`;
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Lenis smooth scroll ---------- */
  function initLenis() {
    if (reduceMotion || typeof Lenis === "undefined") return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, touchMultiplier: 1.5 });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    window.__lenis = lenis;
  }

  /* ---------- Size selector (PDP + quick add) ---------- */
  function initSizeSelectors() {
    document.querySelectorAll("[data-size-group]").forEach((group) => {
      group.querySelectorAll("[data-variant-id]").forEach((btn) => {
        btn.addEventListener("click", () => {
          group.querySelectorAll("[data-variant-id]").forEach((b) => b.classList.remove("selected"));
          btn.classList.add("selected");
          const input = group.parentElement.querySelector("[data-selected-variant]");
          if (input) input.value = btn.dataset.variantId;
        });
      });
    });
  }

  /* ---------- Cart (Shopify AJAX API) ---------- */
  const Cart = {
    overlay: null, drawer: null, itemsEl: null, footEl: null, countEls: [],
    init() {
      this.overlay = document.getElementById("cart-overlay");
      this.drawer = document.getElementById("cart-drawer");
      this.itemsEl = document.getElementById("cart-items");
      this.footEl = document.getElementById("cart-foot");
      this.countEls = Array.from(document.querySelectorAll("[data-cart-count]"));
      document.querySelectorAll("[data-open-cart]").forEach((b) => b.addEventListener("click", () => this.open()));
      document.querySelectorAll("[data-close-cart]").forEach((b) => b.addEventListener("click", () => this.close()));
      document.addEventListener("click", (e) => {
        const addBtn = e.target.closest("[data-add-to-cart]");
        if (addBtn) { e.preventDefault(); this.add(addBtn); }
        const minus = e.target.closest("[data-qty-down]");
        const plus = e.target.closest("[data-qty-up]");
        const remove = e.target.closest("[data-remove]");
        if (minus) this.change(minus.dataset.key, parseInt(minus.dataset.qty) - 1);
        if (plus) this.change(plus.dataset.key, parseInt(plus.dataset.qty) + 1);
        if (remove) this.change(remove.dataset.key, 0);
      });
      this.refresh();
    },
    open() { this.overlay && this.overlay.classList.add("open"); this.drawer && this.drawer.classList.add("open"); document.documentElement.style.overflow = "hidden"; },
    close() { this.overlay && this.overlay.classList.remove("open"); this.drawer && this.drawer.classList.remove("open"); document.documentElement.style.overflow = ""; },
    async add(btn) {
      let id = btn.dataset.variantId;

      const group = btn.closest("[data-product], [data-product-form], .product-info, .product-page, form");

      if (group) {
        const sel = group.querySelector("[data-selected-variant]");
       if (sel && sel.value) id = sel.value;

        const quickSize = group.querySelector("[data-product-size]");
        if (quickSize && quickSize.value) id = quickSize.value;
      }

      if (!id) return;

      btn.disabled = true;

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(id), quantity: 1 })
        });

        await this.refresh();
        this.open();
      } finally {
        btn.disabled = false;
      }
    },
    async change(key, qty) {
      await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) });
      await this.refresh();
    },
    async refresh() {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      this.countEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "flex" : "none";
      });
      if (!this.itemsEl) return;
      if (cart.item_count === 0) {
        this.itemsEl.innerHTML = '<div class="cart-empty"><p class="kicker" style="font-size:.6rem">Your cart is empty</p></div>';
        if (this.footEl) this.footEl.style.display = "none";
        return;
      }
      if (this.footEl) this.footEl.style.display = "block";
      this.itemsEl.innerHTML = cart.items.map((item) => `
        <div class="cart-line">
          <img src="${item.image ? item.image.replace(/(\.[^.]+)$/, "_160x$1") : ""}" alt="${item.product_title}">
          <div class="info">
            <div style="display:flex;justify-content:space-between;gap:.5rem">
              <span class="font-display" style="font-size:.8rem;font-weight:600;text-transform:uppercase">${item.product_title}</span>
              <span class="font-display" style="font-size:.8rem;font-weight:600">${money(item.final_line_price)}</span>
            </div>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<span class="muted" style="font-size:.7rem;margin-top:.2rem">${item.variant_title}</span>` : ""}
            <div class="qty">
              <button data-qty-down data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button data-qty-up data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase">+</button>
            </div>
          </div>
          <button data-remove data-key="${item.key}" aria-label="Remove" style="background:none;border:none;align-self:start;font-size:.7rem" class="kicker muted">✕</button>
        </div>`).join("");
      const totalEl = document.getElementById("cart-total");
      if (totalEl) totalEl.textContent = money(cart.total_price);
    },
  };

  /* ---------- Wishlist (localStorage) ---------- */
  function initWishlist() {
    const KEY = "tb_wishlist";
    const get = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
    const set = (v) => localStorage.setItem(KEY, JSON.stringify(v));
    const sync = () => {
      const list = get();
      document.querySelectorAll("[data-wishlist]").forEach((b) => b.classList.toggle("active", list.includes(b.dataset.wishlist)));
    };
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-wishlist]");
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.wishlist;
      let list = get();
      list = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
      set(list);
      sync();
    });
    sync();
  }

  document.addEventListener("DOMContentLoaded", () => {
    initWordReveal();
    initReveal();
    initMarquee();
    initHeader();
    initMobileMenu();
    initHeroParallax();
    initHorizontalLookbook();
    initCursor();
    initLenis();
    initSizeSelectors();
    initWishlist();
    Cart.init();
  });
})();
